const coreComponent = require('../../../../../core/themes/base/components/component/component');

const component = Object.assign({}, coreComponent, {

});

module.exports = component;

